(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/kyc/kyc-questions.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/kyc/kyc-questions.js');
'use strict';

const {
  useRef,
  useEffect,
  useCallback
} = React;
const {
  useHistory
} = ReactRouterDOM;
const helpers = svs.myProfile.react.pages.kyc.kycHelpers;
const {
  routes
} = svs.myProfile.constants;
const {
  showTechnicalKycError
} = svs.myProfile.react.pages.kyc.dialogs;
const isPnp = svs.core.config.data.svsconfig.site === 'momang';
const KycQuestions = () => {
  const kycContainerRef = useRef();
  const history = useHistory();
  const navigateToNext = useCallback(async () => {
    const returnUrl = helpers.getReturnUrl() || svs.core.urlMapping.get('newCustomer');
    if (returnUrl) {
      svs.core.flash('success', {
        title: 'Dina svar har sparats',
        branding: isPnp ? svs.ui.dialog.branding.MOMANG : svs.ui.dialog.branding.SPORT,
        time: svs.ui.dialog.autoClose.SHORT
      }, () => {
        window.location = returnUrl;
      });
    } else {
      history.push(routes.MY_PROFILE_KYC);
      const dialog = new svs.ui.dialog.Confirm({
        branding: isPnp ? svs.ui.dialog.branding.MOMANG : svs.ui.dialog.branding.SPORT,
        area: svs.ui.dialog.area.POPUP,
        autoClose: svs.ui.dialog.autoClose.SHORT,
        title: 'Dina svar har sparats',
        actions: [{
          type: svs.ui.dialog.button.SECONDARY,
          title: 'Okej'
        }]
      });
      svs.ui.dialog.api.add(dialog);
    }
  }, [history]);

  const onKycQuestionsComplete = useCallback(async (context, kycStatus) => {
    if (kycStatus) {
      const showTechnicalKycMessage = () => new Promise(resolve => {
        svs.core.module.load('/cl/components/kyc-messages', null, () => {
          svs.components.kyc_messages.showKYCMessage(kycStatus, () => resolve());
        });
      });
      await showTechnicalKycMessage();
    }
    navigateToNext();
  }, [navigateToNext]);
  useEffect(() => {
    const kycErrorCallback = async () => {
      await showTechnicalKycError();
      onKycQuestionsComplete();
    };
    const onKycCancel = () => {
      history.push(routes.MY_PROFILE_KYC);
    };
    svs.core.module.load('/cl/components/react:kyc', null, function () {
      svs.components.kyc.init(kycContainerRef.current, {
        context: this,
        onComplete: onKycQuestionsComplete,
        showOverview: false,
        onCancel: onKycCancel,
        onError: kycErrorCallback
      });
    }, false);
  }, [history, onKycQuestionsComplete]);
  return React.createElement("div", {
    ref: kycContainerRef
  });
};
svs.myProfile.react.pages.kyc.KycQuestions = KycQuestions;

 })(window);